/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live countdown to any future date and time.`)
};

const es_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta atrás en vivo hasta cualquier fecha y hora futura.`)
};

const de_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Countdown zu einem beliebigen zukünftigen Datum und Uhrzeit.`)
};

const nl_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live aftelling naar elke toekomstige datum en tijd.`)
};

const fr_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte à rebours en direct vers une date et une heure futures.`)
};

const it_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conto alla rovescia in tempo reale verso una data e ora future.`)
};

const pt_br2_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contagem regressiva ao vivo até qualquer data e hora futura.`)
};

const pt_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contagem decrescente ao vivo até qualquer data e hora futuras.`)
};

const ja_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意の未来の日時までのライブカウントダウン。`)
};

const zh_cd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时倒计时到未来任意日期和时间。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_tool_description", locale)
	if (locale === "en") return en_cd_tool_description(inputs)
	if (locale === "es") return es_cd_tool_description(inputs)
	if (locale === "de") return de_cd_tool_description(inputs)
	if (locale === "nl") return nl_cd_tool_description(inputs)
	if (locale === "fr") return fr_cd_tool_description(inputs)
	if (locale === "it") return it_cd_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_cd_tool_description(inputs)
	if (locale === "pt") return pt_cd_tool_description(inputs)
	if (locale === "ja") return ja_cd_tool_description(inputs)
	return zh_cd_tool_description(inputs)
};